import { PaletteMode } from '@mui/material'
import { ThemeOptions } from '@mui/material/styles'

export const newThemeV5 = (mode: PaletteMode = 'light'): ThemeOptions => {
    const palette = {
        mode,
        ...(mode === 'light'
            ? {
                  default: {
                      main: '#EAEAEA',
                      dark: '#E0E0E0',
                      light: '#EAEAEA',
                      contrastText: 'rgba(0, 0, 0, 0.87)',
                  },
                  bluegrey: {
                      main: '#A5B1C2',
                      dark: '#8392a7',
                      light: '#A5B1C2',
                      contrastText: 'rgba(255, 255, 255, 0.87)',
                  },
                  warning: {
                      main: '#ffa500',
                      dark: '#ff9600',
                      light: '#ffa500',
                      lighter: '#ffedcc',
                      contrastText: 'rgba(255, 255, 255, 0.87)',
                  },
                  info: {
                      main: '#0288d1',
                      dark: '#01579b',
                      light: '#0288d1',
                      contrastText: 'rgba(255, 255, 255, 0.87)',
                  },
                  error: {
                      main: '#d32f2f',
                      dark: '#c62828',
                      light: '#d32f2f',
                      contrastText: 'rgba(255, 255, 255, 0.87)',
                  },
                  primary: {
                      main: '#10ac84',
                      dark: '#009d72',
                      light: '#56CBAC',
                      contrastText: 'rgba(255, 255, 255, 0.87)',
                  },
                  invertPrimary: {
                      main: '#ffffff',
                      dark: '#f2f6f8',
                      light: '#ffffff',
                      contrastText: '#10ac84',
                  },
                  secondary: {
                      light: '#aaa',
                      main: '#676767',
                      contrastText: 'rgba(255, 255, 255, 0.87)',
                  },
                  background: {
                      paper: '#ffffff',
                      default: '#f2f6f8',
                  },
                  text: {
                      primary: 'rgba(0, 0, 0, 0.87)',
                  },
                  topside: {
                      default: '#10ac84', // top
                      paper: '#ffffff', // side
                  },
                  disabled: {
                      main: 'rgba(0,0,0,0.12)',
                      light: 'rgba(0,0,0,0.12)',
                      dark: 'rgba(0,0,0,0.12)',
                      contrastText: 'rgba(0,0,0,0.26)',
                  },
                  outlinePrimary: {
                      main: '#ffffff',
                      dark: '#10ac84',
                      light: '#ffffff',
                      contrastText: '#10ac84',
                  },
                  table: {
                      main: '#ffffff',
                      dark: '#f2f6f8',
                      light: '#f7fafc',
                      contrastText: 'rgba(0, 0, 0, 0.87)',
                  },
                  listCollapse: {
                      default: '#efefef', // item
                      paper: '#ffffff', // sub list item
                  },
              }
            : {
                  default: {
                      main: '#666666',
                      dark: '#363636',
                      light: '#666666',
                      contrastText: 'rgba(255, 255, 255, 0.87)',
                  },
                  bluegrey: {
                      main: '#636363',
                      light: '#505050',
                      dark: '#505050',
                      contrastText: 'rgba(255, 255, 255, 0.87)',
                  },
                  warning: {
                      main: '#ffb640',
                      dark: '#ffa500',
                      light: '#ffb640',
                      contrastText: 'rgba(255, 255, 255, 0.87)',
                  },
                  info: {
                      main: '#03a9f4',
                      dark: '#0288d1',
                      light: '#03a9f4',
                      contrastText: 'rgba(255, 255, 255, 0.87)',
                  },
                  error: {
                      main: '#ef5350',
                      dark: '#d32f2f',
                      light: '#ef5350',
                      contrastText: 'rgba(255, 255, 255, 0.87)',
                  },
                  primary: {
                      main: '#47bb99',
                      dark: '#10ac84',
                      light: '#47bb99',
                      contrastText: 'rgba(255, 255, 255, 0.87)',
                  },
                  invertPrimary: {
                      main: '#484848',
                      dark: '#262626',
                      light: '#383838',
                      contrastText: '#47bb99',
                  },
                  secondary: {
                      main: '#636363',
                      contrastText: 'rgba(255, 255, 255, 0.87)',
                  },
                  background: {
                      paper: '#484848',
                      default: '#262626',
                  },
                  text: {
                      primary: 'rgba(255, 255, 255, 0.87)',
                  },
                  topside: {
                      default: '#323232', // top
                      paper: '#323232', // side
                  },
                  disabled: {
                      main: 'rgba(255,255,255,0.12)',
                      light: 'rgba(255,255,255,0.12)',
                      dark: 'rgba(255,255,255,0.12)',
                      contrastText: 'rgba(255,255,255,0.3)',
                  },
                  outlinePrimary: {
                      main: '#47bb99',
                      dark: '#10ac84',
                      light: '#47bb99',
                      contrastText: 'rgba(255, 255, 255, 0.87)',
                  },
                  table: {
                      main: '#323232',
                      dark: '#262626',
                      light: '#383838',
                      contrastText: 'rgba(255, 255, 255, 0.87)',
                  },
                  listCollapse: {
                      default: '#323232', // item
                      paper: '#262626', // sub list item
                  },
              }),
    }

    return {
        components: {
            MuiAutocomplete: {
                defaultProps: {
                    size: 'small',
                },
            },
            MuiCard: {
                styleOverrides: {
                    root: {
                        borderRadius: 0,
                        backgroundImage: 'none',
                    },
                },
            },
            MuiCardContent: {
                styleOverrides: {
                    root: {
                        backgroundColor: palette.background.paper,
                    },
                },
            },
            MuiButton: {
                defaultProps: {
                    variant: 'contained',
                    color: 'secondary',
                },
            },
            MuiTextField: {
                defaultProps: {
                    size: 'small',
                },
            },
            MuiDialogTitle: {
                styleOverrides: {
                    root: {
                        backgroundColor: palette.topside.default,
                        color: 'rgba(255, 255, 255, 0.87)',
                    },
                },
            },
            MuiDialogContent: {
                defaultProps: {
                    dividers: true,
                },
                styleOverrides: {
                    root: {
                        backgroundColor: palette.background.paper,
                    },
                },
            },
            MuiDialogActions: {
                styleOverrides: {
                    root: {
                        backgroundColor: palette.background.paper,
                    },
                },
            },
            MuiPaper: {
                styleOverrides: {
                    root: {
                        backgroundImage: 'none',
                    },
                },
            },
            MuiListItemButton: {
                styleOverrides: {
                    root: {
                        backgroundColor: palette.background.default,
                        '&.Mui-selected': {
                            backgroundColor:
                                palette.mode === 'dark'
                                    ? palette.default.dark
                                    : palette.default.main,
                            borderLeft: `5px solid ${palette.primary.main}`,
                        },
                    },
                },
            },
            MuiList: {
                styleOverrides: {
                    root: {
                        backgroundColor: palette.background.paper,
                        WebkitOverflowScrolling: 'touch',
                    },
                },
            },
            MuiFormControlLabel: {
                styleOverrides: {
                    root: {
                        marginRight: 8,
                    },
                },
            },
            MuiTooltip: {
                styleOverrides: {
                    tooltip: {
                        borderRadius: 0,
                        fontSize: 12,
                        padding: 10,
                    },
                },
            },
            MuiTableBody: {
                styleOverrides: {
                    root: {
                        borderBottomColor: palette.table.dark,
                        backgroundColor: palette.table.main,
                    },
                },
            },
            MuiTableHead: {
                styleOverrides: {
                    root: {
                        backgroundColor: palette.table.dark,
                    },
                },
            },
            MuiTableCell: {
                styleOverrides: {
                    root: {
                        borderColor: palette.default.main,
                    },
                },
            },
            MuiAccordionSummary: {
                styleOverrides: {
                    root: {
                        backgroundColor: palette.background.default,
                    },
                },
            },
        },
        typography: {
            fontFamily: '"Open Sans", sans-serif',
            button: {
                textTransform: 'uppercase',
            },
        },
        palette,
    }
}
